import { mdiCheckboxBlankCircleOutline } from "@mdi/js";
import setVuetifyColorsCssVariables from "@/@core/utils/colors";

const themeConfig = {
  app: {
    name: "SiteRunner",
    domain: "SiteRunner.com",
    logo: require("@/assets/images/svg/logo.svg"),
    theme: "light", // light, dark, pepe
    isDark: false,
    isRtl: false,
    contentLayoutNav: "vertical", // vertical, horizontal
    routeTransition: "scroll-x-transition", // https://vuetifyjs.com/en/styles/transitions/#api
    // ! `semi-dark` isn't available for horizontal nav menu
    skinVariant: "bordered", // default, bordered, semi-dark
    contentWidth: "full",
  },
  menu: {
    isMenuHidden: false,
    isVerticalNavMini: false,
    verticalMenuAccordion: true,
    groupChildIcon: mdiCheckboxBlankCircleOutline,
    horizontalNavMenuGroupOpenOnHover: true,
  },
  appBar: {
    /*
    ! In Content Layout Horizontal Nav type `hidden` value won't work
    ! In Content Layout Horizontal Nav type value of `type` will affect both Appbar and Horizontal Navigation Menu
    */
    type: "static", // fixed, static, hidden
    isBlurred: false,
  },
  footer: {
    type: "static", // fixed, static, hidden
  },
  themes: {
    light: {
      /**
       * PRIMARY COLORS
       */
      primary: "#6A49EF",
      "primary-hover": "#886df2",
      "primary-65": "#AD9BF6",
      "primary-20": "#E1DBFC",
      "primary-10-hover": "#F7F6FF",
      "secondary-btn": "#6A49EF",
      "primary-65-trial": "#E1DBFC",
      /**
       * NEUTRAL COLORS
       */
      icon: "#939099",
      border: "#DAD9DD",
      "element-bg-300": "#EEEEEE",
      "element-bg-200": "#F4F4F4",
      "element-bg-100": "#FFFFFF",
      hover: "#FAFAFA",
      white: "#FFFFFF",
      background: "#F4F5FA",
      /**
       * TEXT COLORS
       */
      headline: "#201F37",
      body: "#45404E",
      subtitle: "#6C6C7D",
      "headline-element-bg-200-trial": "#201F37",
      "primary-menu-trial": "#6A49EF",
      /**
       * ACCENT COLORS
       */
      error: "#FF4C51",
      "error-hover": "#FF7074",
      "error-120": "#ff4c5121",
      warning: "#FFB400",
      "warning-100": "#FFF5DE",
      "warning-120": "#ffb40033",
      success: "#22B94D",
      "success-accent": "#057C27",
      "success-120": "#22b94d1e",
      disabled: "#939099",
      /** Info is mapped to Accent in variables.scss (when passing :color prop to vuetify components, use 'info')*/
      info: "#0D6EFD",
      "info-120": "#0d6efd1e",
      /**
       * SAME COLORS
       */
      "same-white": "#ffffff",
      "same-menu-text": "#AFAAC1",
      "same-menu-hover": "#312D4B",
      "same-menu": "#28243d",
      "same-divider": "#564A7A",
      "same-hover": "#886DF2",
      "same-headline": "#201F37",
      "same-border": "#DAD9DD",
      "same-subtitle": "#6C6C7D",
      "same-body": "#45404E",
      "same-icon": "#939099",
      "same-element-bg-200": "#F4F4F4",
      "same-secondary-btn": "#6A49EF",
      "same-primary-20": "#E1DBFC",
      "same-hover-neutral": "#FAFAFA",
    },
    dark: {
      /**
       * PRIMARY COLORS
       */
      primary: "#6A49EF",
      "primary-hover": "#6A49EFCC",
      "primary-65": "#6A49EF8C",
      "primary-20": "#6A49EF33",
      "primary-10-hover": "#564A7A",
      "secondary-btn": "#FFFFFF",
      "primary-65-trial": "#AD9BF6",
      /**
       * NEUTRAL COLORS
       */
      icon: "#DDDDE0",
      border: "#6B6785",
      "element-bg-300": "#3A3657",
      "element-bg-200": "#373256",
      "element-bg-100": "#312D4B",
      hover: "#3E395D",
      /**
       * (element-bg-200) TODO: issiaiskint kas ten tureta omeny figmoj
       * Visur spalva keiciasi isskyrus card komponente?
       */
      white: "#312D4B",
      background: "#28243d",
      /**
       * TEXT COLORS
       */
      headline: "#FFFFFF",
      body: "#E8E6F0",
      subtitle: "#AFAAC1",
      "headline-element-bg-200-trial": "#373256",
      "primary-menu-trial": "#28243D",
      /**
       * ACCENT COLORS
       */
      error: "#FF4C51",
      "error-hover": "#FF7074",
      "error-120": "#ff4c5121",
      warning: "#FFB400",
      "warning-100": "#FFF5DE",
      "warning-120": "#ffb40033",
      success: "#22B94D",
      "success-120": "#22b94d1e",
      disabled: "#564A7A",
      /** Info is mapped to Accent in variables.scss */
      info: "#0D6EFD",
      "info-120": "#0d6efd1e",
      /**
       * SAME COLORS
       */
      "same-white": "#ffffff",
      "same-menu-text": "#AFAAC1",
      "same-menu-hover": "#312D4B",
      "same-menu": "#28243d",
      "same-divider": "#564A7A",
      "same-hover": "#886DF2",
      "same-headline": "#201F37",
      "same-border": "#DAD9DD",
      "same-subtitle": "#6C6C7D",
      "same-body": "#45404E",
      "same-icon": "#939099",
      "same-element-bg-200": "#F4F4F4",
      "same-secondary-btn": "#6A49EF",
      "same-primary-20": "#E1DBFC",
      "same-hover-neutral": "#FAFAFA",
    },
    pepe: {
      /**
       * PRIMARY COLORS
       */
      primary: "#3AA655",
      "primary-hover": "#3AA655CC",
      "primary-65": "#3AA6558C",
      "primary-20": "#3AA65533",
      "primary-10-hover": "#2F8A43",
      "secondary-btn": "#FFFFFF",
      "primary-65-trial": "#83C296",
      /**
       * NEUTRAL COLORS
       */
      icon: "#DDDDE0",
      border: "#6B6785",
      "element-bg-300": "#2C2B3D",
      "element-bg-200": "#26252E",
      "element-bg-100": "#1F1F27",
      hover: "#35343E",
      white: "#1F1F27",
      background: "#1B1A23",
      /**
       * TEXT COLORS
       */
      headline: "#FFFFFF",
      body: "#E8E6F0",
      subtitle: "#AFAAC1",
      "headline-element-bg-200-trial": "#26252E",
      "primary-menu-trial": "#1B1A23",
      /**
       * ACCENT COLORS
       */
      error: "#FF4C51",
      "error-hover": "#FF7074",
      "error-120": "#ff4c5121",
      warning: "#FFB400",
      "warning-100": "#FFF5DE",
      "warning-120": "#ffb40033",
      success: "#22B94D",
      "success-accent": "#057C27",
      "success-120": "#22b94d1e",
      disabled: "#4B4A6D",
      /** Info is mapped to Accent in variables.scss (when passing :color prop to vuetify components, use 'info')*/
      info: "#0D6EFD",
      "info-120": "#0d6efd1e",
      /**
       * SAME COLORS
       */
      "same-white": "#FFFFFF",
      "same-menu-text": "#AFAAC1",
      "same-menu-hover": "#1F1F27",
      "same-menu": "#1B1A23",
      "same-divider": "#4B4A6D",
      "same-hover": "#3AA655",
      "same-headline": "#201F37",
      "same-border": "#DAD9DD",
      "same-subtitle": "#6C6C7D",
      "same-body": "#45404E",
      "same-icon": "#939099",
      "same-element-bg-200": "#F4F4F4",
      "same-secondary-btn": "#3AA655",
      "same-primary-20": "#C7E2CD",
      "same-hover-neutral": "#FAFAFA",
    },
  },
};

(() => {
  if (localStorage.getItem("materio-active-theme") === "pepe") {
    setVuetifyColorsCssVariables(themeConfig, "pepe");
  } else {
    setVuetifyColorsCssVariables(
      themeConfig,
      localStorage.getItem("materio-active-theme") === null
        ? themeConfig.app.isDark
          ? "dark"
          : "light"
        : localStorage.getItem("materio-active-theme") === "dark"
        ? "dark"
        : "light",
    );
  }
})();

export default themeConfig;
